import petProductService from 'bff/services/petProductService';
import { question, STEP, styles } from 'containers/InsureProcess/InsureProcseePet/types';
import { ErrorMessage, Field, FieldArray, Form, Formik, getIn } from 'formik';
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { setRuleValidErrorModalVisible, setVetHospitalModalVisibleAction } from 'redux/actions/modal.action';
import { Dispatch } from 'redux';
import * as Yup from 'yup';
import commonService from 'utils/commonService';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import PetFormikFocusError from './PetFormikFocusError';
import VetHospital from './VetHospital';

const initForm3 = {
  ask: [{
    KYC_ID: '',
    KYC_ANSWER: '',
    KYC_OTHER: ''
  }],
  inform: [{
    KYC_ID: '',
    KYC_ANSWER: '',
    KYC_OTHER: ''
  }]
};

const validationSchema = Yup.object().shape({
  ask: Yup.array().of(
    Yup.object().shape({
      KYC_ID: Yup.string().required('此為必填欄位'),
      KYC_ANSWER: Yup.string().required('此為必填欄位')
    })
  ),
  inform: Yup.array().of(
    Yup.object().shape({
      KYC_ID: Yup.string().required('此為必填欄位'),
      KYC_ANSWER: Yup.string().required('此為必填欄位'),
      KYC_OTHER: Yup.string().when(['KYC_ANSWER', 'KYC_ID'], (kycAnswer: any, kycId: any, schema: any) => {
        return kycAnswer && kycAnswer === 'Y' && kycId === 'KYCN02' ? schema.required('請輸入治療中之傷病') : schema;
      })
    })
  )
});

function InsureProcessInform (props: any) {
  const formikRef3: any = useRef();

  const showVetHospitalModal = () => {
    props.setVetHospitalModalVisible(true);
  };

  const handleFormSubmit = async (val: any) => {
    console.log('🚀 ~ step3 val:', val);

    const validReq = JSON.parse(JSON.stringify(props.state.validReq));
    const KYC_DATA = validReq.RULECHECK.KYC_DATA.concat(val.ask).concat(val.inform);
    validReq.RULECHECK.KYC_DATA = KYC_DATA;
    validReq.CHECK_TYPE = 'F';

    const validRes = await petProductService.validPetInsRule(validReq);

    if (!validRes) return;

    // 檢核未通過
    if (validRes.TRANRS.ERROR_MSG.length > 0) {
      props.setRuleValidErrorModalVisible(true, validRes.TRANRS.ERROR_MSG);
      return;
    }

    props.setState((prev:any) => ({
      ...prev,
      validReq2: validReq,
      validRes
    }));

    const originTempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState));
    const tempData = {
      ...originTempData,
      validReq2: validReq,
      validRes
    };
    commonService.storageData(storageKeys.InsurceProcessPetState, tempData);

    props.handleStep(STEP.preview);
  };

  const setTempFieldValue = async (tempData: any, setFieldValue: any) => {
    await setFieldValue('ask', tempData.ask ? [...tempData.ask] : [{
      KYC_ID: '',
      KYC_ANSWER: ''
    }], true);
    await setFieldValue('inform', tempData.inform ? [...tempData.inform] : [{
      KYC_ID: '',
      KYC_ANSWER: ''
    }], true);
  };

  const handleVetHospitalMapCancel = () => {
    formikRef3.current.setFieldValue('ask[5].KYC_ANSWER', 'N');
  };

  useEffect(() => {
    const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState)) ? JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState)).tempInformForm : null;
    if (!tempData && formikRef3.current) {
      initForm3.ask = [];
      props.formField.ask.forEach((ask: question) => {
        initForm3.ask.push({
          KYC_ID: ask.KYC_ID,
          KYC_ANSWER: '',
          KYC_OTHER: ''
        });
      });
      initForm3.inform = [];
      props.formField.inform.forEach((inform: question) => {
        initForm3.inform.push({
          KYC_ID: inform.KYC_ID,
          KYC_ANSWER: '',
          KYC_OTHER: ''
        });
      });
    }
  }, [props.formField.ask, props.formField.inform]);

  useEffect(() => {
    const tempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState)) ? JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState)).tempInformForm : null;
    if (tempData && formikRef3.current) {
      setTempFieldValue(tempData, formikRef3.current.setFieldValue);
    }
    return () => {
      const originTempData = JSON.parse(storageService.getItem(storageKeys.InsurceProcessPetState));
      const tempData = {
        ...originTempData,
        tempInformForm: formikRef3.current.values
      };
      commonService.storageData(storageKeys.InsurceProcessPetState, tempData);
    };
  }, []);

  return (
    <div className="insure-process--travel">
      <div className="insure-process-building-info insure-process-fill" style={props.activeStep === STEP.infoCheck ? undefined : styles.inline}>
        <Formik
          innerRef={formikRef3}
          initialValues={initForm3}
          validationSchema={validationSchema}
          onSubmit={handleFormSubmit}
        >
          {({ values, errors, touched, handleBlur, handleChange, setFieldValue, setFieldTouched }) => (
            <Form>
              <div className="insure-process-fill__content">
                {/* 詢問事項 */}
                <div className="statement">
                  <div className="statement__title">詢問事項</div>
                  <div className="statement__content">
                    <div className="statement__form" style={{ outline: 'none' }}>
                      <FieldArray name="ask">{() => (
                        props.formField.ask.map((ask: question, index: number) => (
                          <div
                            className={'element__form-group' + (
                              getIn(errors, `ask[${index}].KYC_ANSWER`) && getIn(touched, `ask[${index}].KYC_ANSWER`)
                                ? ' element__form-group--invalid'
                                : '')} key={ask.KYC_ID}
                          >
                            <div className="element__form-group-title">{commonService.htmlParser(ask.KYC_SUBJECT)} </div>
                            <div className="element__form-group-content">
                              {ask.KYC_OPTIONS.map((opt: any) => (
                                <div key={ask.KYC_ID + opt.KEY} className="element__radio-group">
                                  <label htmlFor={`ask-${index}-${opt.KEY}`}>
                                    <div className="element__radio">
                                      <Field
                                        type="radio"
                                        name={`ask[${index}].KYC_ANSWER`}
                                        id={`ask-${index}-${opt.KEY}`}
                                        value={opt.KEY}
                                        data-fieldname={`ask-${index}`}
                                        onClick={ask.KYC_ID === 'KYCQ06' && opt.KEY === 'Y' ? showVetHospitalModal : undefined}
                                      />
                                      <div className="element__radio-btn" />
                                    </div>
                                    <span>{opt.VAL}</span>
                                  </label>
                                </div>
                              ))}
                            </div>
                            <div className="element__error-message">
                              <ErrorMessage name={`ask[${index}].KYC_ANSWER`} />
                            </div>
                          </div>
                        ))
                      )}
                      </FieldArray>
                    </div>
                  </div>
                </div>
                {/* 告知事項 */}
                <div className="statement">
                  <div className="statement__title">告知事項</div>
                  <div className="statement__content">
                    <div className="statement__form" style={{ outline: 'none' }}>
                      {props.formField.inform.map((inform: question, index: number) => (
                        <div
                          className={'element__form-group' + (
                            (getIn(errors, `inform[${index}].KYC_ANSWER`) && getIn(touched, `inform[${index}].KYC_ANSWER`)) || (getIn(errors, `inform[${index}].KYC_OTHER`) && getIn(touched, `inform[${index}].KYC_OTHER`))
                              ? ' element__form-group--invalid'
                              : '')} key={inform.KYC_ID}
                        >
                          <div className="element__form-group-title">{commonService.htmlParser(inform.KYC_SUBJECT)}</div>
                          <div className="element__form-group-content">
                            {inform.KYC_OPTIONS.map((opt: any) => (
                              <div key={inform.KYC_ID + opt.KEY} className="element__radio-group">
                                <label htmlFor={`inform-${index}-${opt.KEY}`}>
                                  <div className="element__radio">
                                    <Field
                                      type="radio"
                                      name={`inform[${index}].KYC_ANSWER`}
                                      id={`inform-${index}-${opt.KEY}`}
                                      value={opt.KEY}
                                      onChange={(e:any) => {
                                        if (e.currentTarget.value !== 'Y' && getIn(values, `inform[${index}].KYC_OTHER`)) {
                                          setFieldValue(`inform[${index}].KYC_OTHER`, '', false);
                                        }
                                        setFieldValue(`inform[${index}].KYC_ANSWER`, opt.KEY);
                                      }}
                                    />
                                    <div className="element__radio-btn" />
                                  </div>
                                  <span>{opt.VAL}</span>
                                </label>
                                {
                                  inform.KYC_ID === 'KYCN02' && opt.KEY === 'Y'
                                    ? <Field
                                      maxLength={50}
                                      autoComplete="off"
                                      disabled={getIn(values, `inform[${index}].KYC_ANSWER`) !== 'Y'}
                                      type="text"
                                      name={`inform[${index}].KYC_OTHER`}
                                      id={`inform-${index}-input`}
                                      className="element__input custom-input"
                                      placeholder="請輸入治療中之傷病 "
                                      data-fieldname={`inform-${index}`}
                                    // eslint-disable-next-line react/jsx-closing-bracket-location
                                    />
                                    : null
                                }
                              </div>
                            ))}
                          </div>
                          <div className="element__error-message">
                            <ErrorMessage name={`inform[${index}].KYC_ANSWER`} />
                            <ErrorMessage name={`inform[${index}].KYC_OTHER`} />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              {/* form3 submit */}
              <div className="insure-process-building-info__controls pet-controls">
                <button type="button" className="element__button element__button--red-border" onClick={() => props.handleStep(STEP.infoFill)}>返回上一頁</button>
                <button type="submit" className="element__button element__button--red">下一步</button>
              </div>
              <PetFormikFocusError inform />
              <VetHospital {...{ handleVetHospitalMapCancel }} />
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

const mapDisatchToProps = (dispatch: Dispatch) => {
  return {
    setRuleValidErrorModalVisible: (visible: boolean, errorMsgs: any[]) => dispatch(setRuleValidErrorModalVisible(visible, errorMsgs)),
    setVetHospitalModalVisible: (visible: boolean) => dispatch(setVetHospitalModalVisibleAction(visible))
  };
};

export default connect(null, mapDisatchToProps)(InsureProcessInform);
